import { useSelector } from 'react-redux';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { AssetActionsProvider, AssetActionsDropdown, AssetActionButton, ACTION_IDS } from 'asset-actions-lib';
import { FORM_ACTION_IDS } from 'asset-actions-lib-forms/constants/actionIds';
import formActions from 'asset-actions-lib-forms';
import { getAnalyticsDateRange
// @ts-expect-error untyped dependency
} from 'FormsUI/selectors/Dashboard';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import useActionsLib from './hooks/useActionsLib';
import moveToFolderAction from './actionOverrides/moveToFolderAction';
import viewNonHSInformationAction from './actionOverrides/viewNonHSInformationAction';
import convertNonHSFormAction from './actionOverrides/convertNonHSAction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HoverContentActionsLib({
  crmObject
}) {
  const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
  const dateRange = useSelector(getAnalyticsDateRange);
  const {
    handleActionError,
    handleActionSuccess,
    handleOnTrackEvent
  } = useActionsLib(String(formType));
  return /*#__PURE__*/_jsx(AssetActionsProvider, {
    actions: formActions,
    actionsConfigOverrides: [
    /**
     * The three overrides below won't be migrated to asset-actions-lib.
     *
     * - "Move to folder" depends on framework-listing-lib's internal implementation and we (#marketing-platform) need a better strategy for this action before making it "shareable".
     * - Both "View non HS Info" and "Convert non HS Form" are heavily dependant on redux + several utility methods that live inside FormsUI which makes it super hard to migrate over.
     */
    moveToFolderAction, viewNonHSInformationAction, convertNonHSFormAction],
    crmObject: crmObject,
    nonCrmObject: {
      type: 'DASHBOARD',
      dateRange
    },
    onActionSuccess: handleActionSuccess,
    onActionError: handleActionError,
    trackerProps: {
      applicationId: 'FormsUI',
      onTrackEvent: handleOnTrackEvent
    },
    layoutUse: "hover-actions",
    children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
      children: [/*#__PURE__*/_jsx(AssetActionButton, {
        actionId: ACTION_IDS.EDIT
      }), /*#__PURE__*/_jsx(AssetActionButton, {
        actionId: FORM_ACTION_IDS.CLONE
      }), /*#__PURE__*/_jsx(AssetActionsDropdown, {
        actionIdsToExclude: [FORM_ACTION_IDS.CLONE, ACTION_IDS.EDIT]
      })]
    })
  });
}